import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "navigation-wrapper" }
const _hoisted_2 = { class: "navigation-split-right" }
const _hoisted_3 = { class: "navigation-main nav" }
const _hoisted_4 = {
  key: 0,
  class: "my-badge tl bg-color-danger notification-badge"
}
const _hoisted_5 = {
  key: 1,
  class: "my-badge tl dot bg-color-danger"
}
const _hoisted_6 = { class: "sub-menu" }
const _hoisted_7 = { class: "flex align-items-center py-5 gap-4 clear-both" }
const _hoisted_8 = {
  key: 0,
  class: "my-badge bg-color-danger notification-badge position-relative mt--5"
}
const _hoisted_9 = {
  key: 1,
  class: "my-badge dot bg-color-danger position-relative mt--5"
}
const _hoisted_10 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_11 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex align-items-center mb-2" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "size-md rounded-100 mr-3 bg-grey-200 flex align-items-center justify-content-center"
}
const _hoisted_17 = { class: "text-xs" }
const _hoisted_18 = { class: "flex-1" }
const _hoisted_19 = { class: "font-normal text-black my-1" }
const _hoisted_20 = { class: "text-sm text-grey-500 mb-0" }
const _hoisted_21 = { class: "my-badge br2 bg-color-danger notification-badge" }
const _hoisted_22 = {
  key: 0,
  class: "text-sm text-grey-500 mt-2"
}
const _hoisted_23 = { class: "text-xs text-grey-400 mt-1" }

import { ref, onMounted, computed, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import axios from 'axios';
    import { useNotificationStore } from '@/stores/notificationStore';
    import chatService, { type ChatConversation } from '@/services/chatService';
    import { cleanupSocketListeners } from '@/services/socketListenerService';
    import { formatDate } from '@/utils';

    // eslint-disable-next-line no-undef
    
export default /*@__PURE__*/_defineComponent({
  __name: 'NavbarLayout',
  props: ['appSidebarOpened'],
  setup(__props) {

    const props = __props
    const router = useRouter();
    const notificationStore = useNotificationStore();

    const appNavigationOpened = ref(false);
    const conversationsWithUnread = ref<ChatConversation[]>([]);
    const loadingNotifications = ref(false);

    // Compteur total de messages non lus
    const unreadCount = computed(() => notificationStore.unreadMessagesCount);

    // Surveiller les changements du store pour rafraîchir la liste si le widget est ouvert
    watch(() => notificationStore.unreadMessagesCount, () => {
        if (appNavigationOpened.value) {
            loadNotifications();
        }
    });

    function toggleAppNavigation(isOpen: boolean) {
        appNavigationOpened.value = isOpen;
        if (isOpen) {
            loadNotifications();
        }
    }

    // Charger les conversations avec messages non lus
    async function loadNotifications() {
        try {
            loadingNotifications.value = true;
            const allConversations = await chatService.getConversations();
            // Filtrer seulement celles avec des messages non lus
            conversationsWithUnread.value = allConversations.filter(conv => {
                const unread = notificationStore.getUnreadForConversation(conv.id);
                return unread > 0 || (conv.unreadCount && conv.unreadCount > 0);
            });
        } catch (error) {
            console.error('Erreur lors du chargement des notifications:', error);
        } finally {
            loadingNotifications.value = false;
        }
    }

    // Aller à une conversation
    function goToConversation(conversationId: number) {
        toggleAppNavigation(false);
        router.push(`/app/service-client/${conversationId}`);
    }

    function doLogout() {
        // Nettoyer les listeners Socket.IO avant la déconnexion
        cleanupSocketListeners();

        const accessToken = localStorage.getItem('LS_COOP_FINANCE_BO_ACCESS_TOKEN');
        axios.post('/backoffice/auth/signout', {}, { headers: { Authorization: `Bearer ${accessToken}` } });
        localStorage.removeItem('LS_COOP_FINANCE_BO_ACCESS_TOKEN');
        localStorage.removeItem('LS_COOP_FINANCE_BO_AUTH_USER');
        router.replace('/auth/login');
    }

    // Obtenir le type de conversation en français
    function getTypeLabel(type: string): string {
        const types: Record<string, string> = {
            'general': 'Général',
            'reclamation': 'Réclamation',
            'remboursement': 'Remboursement',
            'compte': 'Problème compte',
            'carte': 'Carte',
            'autre': 'Autre',
        };
        return types[type] || type;
    }

    // Obtenir le nombre de messages non lus pour une conversation
    function getUnreadForConversation(conversationId: number): number {
        return notificationStore.getUnreadForConversation(conversationId);
    }

    onMounted(() => {
        // Charger les notifications initiales
        loadNotifications();

        // Note: Les listeners Socket.IO sont maintenant gérés globalement
        // via socketListenerService.ts, initialisé dans le router
        // On utilise un watcher sur le store pour rafraîchir la liste si besoin

        // Rafraîchir périodiquement (toutes les 30 secondes)
        setInterval(() => {
            if (appNavigationOpened.value) {
                loadNotifications();
            }
        }, 30000);
    });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: _normalizeClass(["app-nav navigation", {'close': !__props.appSidebarOpened}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"navigation-split-left\"><div class=\"s10_mobile flex align-items-center px-5 py-5 gap-4 rounded-50 backdrop-filter\"><img src=\"/icons/icon-menu-securite.svg\" class=\"size-lg\"><h2 class=\"font-semibold text-black\">Sécurité </h2><div class=\"my-badge dot bg-color-notif position-relative mt--5\"></div></div></div>", 1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("nav", _hoisted_3, [
            _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"navigation-search-set\"><div class=\"navigation-search\"><input type=\"text\" name=\"search\" id=\"search\" class=\"navigation-search-field\" placeholder=\"Rechercher   #module\"><div class=\"navigation-search-effect\"></div></div><div class=\"search-result\"><li><img src=\"/icons/icon-hashtag.svg\"> Module Sécurité</li><li><img src=\"/icons/icon-hashtag.svg\"> Carte Coop Finance</li><li><img src=\"/icons/icon-hashtag.svg\"> Article market place</li><li><img src=\"/icons/icon-hashtag.svg\"> Module Sécurité</li><li><img src=\"/icons/icon-hashtag.svg\"> Carte Coop Finance</li><li><img src=\"/icons/icon-hashtag.svg\"> Article market place</li></div></div>", 1)),
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                class: "btn-action tips bottom active mx-3 notification-open",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleAppNavigation(true)))
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("img", {
                  src: "/icons/icon-notification.svg",
                  class: "btn-action-icon black",
                  alt: ""
                }, null, -1)),
                (unreadCount.value > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(unreadCount.value > 99 ? '99+' : unreadCount.value), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5))
              ]),
              _createElementVNode("li", null, [
                _cache[6] || (_cache[6] = _createElementVNode("img", {
                  src: "/assets/users/600w/user11.jpg",
                  class: "user-profil-img rounded-50 mt-1"
                }, null, -1)),
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/app/account" }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("img", {
                          src: "/icons/icon-menu-securite.svg",
                          class: "size-xs icon-white mr-2"
                        }, null, -1),
                        _createTextVNode(" Mon compte ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (doLogout()))
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-deconnexion.svg",
                        class: "size-xs icon-white mr-2"
                      }, null, -1),
                      _createTextVNode(" Déconnexion", -1)
                    ]))])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["widget-notification", {'open': appNavigationOpened.value}])
    }, [
      _createElementVNode("button", {
        class: "btn white white2 px-3 py-3 align-right opacity-7 notification-close",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleAppNavigation(false)))
      }, [...(_cache[9] || (_cache[9] = [
        _createElementVNode("img", {
          src: "/icons/icon-close.svg",
          class: "size-sm icon-black"
        }, null, -1)
      ]))]),
      _createElementVNode("div", _hoisted_7, [
        _cache[10] || (_cache[10] = _createElementVNode("img", {
          src: "/icons/icon-notification.svg",
          class: "size-lg"
        }, null, -1)),
        _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "font-semibold text-black" }, "Notifications", -1)),
        (unreadCount.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(unreadCount.value > 99 ? '99+' : unreadCount.value), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_9))
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "h-15" }, null, -1)),
      (loadingNotifications.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("p", { class: "text-grey-500" }, "Chargement des notifications...", -1)
          ]))]))
        : (conversationsWithUnread.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("p", { class: "text-grey-500" }, "Aucune notification", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conversationsWithUnread.value, (conversation) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: conversation.id
                }, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(($event: any) => (goToConversation(conversation.id)), ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      (conversation.user?.avatar)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: conversation.user.avatar,
                            class: "size-md rounded-100 mr-3",
                            alt: ""
                          }, null, 8, _hoisted_15))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(conversation.user?.prenom?.[0] || 'U'), 1)
                          ])),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("h6", _hoisted_19, _toDisplayString(conversation.user?.prenom) + " " + _toDisplayString(conversation.user?.nom), 1),
                        _createElementVNode("p", _hoisted_20, _toDisplayString(getTypeLabel(conversation.type)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(getUnreadForConversation(conversation.id) || conversation.unreadCount || 0), 1)
                    ]),
                    (conversation.dernierMessage)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(conversation.dernierMessage.texte.substring(0, 60)) + _toDisplayString(conversation.dernierMessage.texte.length > 60 ? '...' : ''), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(formatDate)(conversation.dernierMessage?.date || conversation.updated_at)), 1)
                  ], 8, _hoisted_13)
                ]))
              }), 128))
            ]))
    ], 2)
  ], 64))
}
}

})